import { lang } from '@umu/ukit-lang';
import { Button, Modal } from '@umu/umu-design';
import React, { forwardRef } from 'react';
import '../../style/caet/complete.scss';
import { CaetThemeBasic } from './basic';
import { PermissionControl } from './components/permissionControl';
import { useCaetComplete } from './hook/useCaetComplete';
import type { ICaetCompleteDialogProps, ICaetCompleteProps, ICaetCompleteRef } from './interface/complete';

const { confirm } = Modal;

const CaetComplete = forwardRef<ICaetCompleteRef, ICaetCompleteProps>((props, ref) => {
    const { hidePermissionControl = false, description = '', isMobile = false } = props;
    // 使用自定义 Hook 管理逻辑
    const {
        isPublic,
        showEmail,
        email,
        isDownloading,
        handlePermissionChange,
        handleDownload,
        handleManage,
        handleConfirm,
        showContentInfo,
        footerButtonsConfig,
        certificateConfig,
        footerRender,
    } = useCaetComplete({
        ...props,
        ref,
    });

    return (
        <div className="complete-ai-power-recognition">
            {/* 主容器 */}
            <div className="complete-ai-power-recognition-container">
                {/* 证书展示区域 */}
                <div className={`certificate-section ${isMobile ? 'mobile-section' : ''}`}>
                    <CaetThemeBasic config={certificateConfig} />
                </div>

                {/* 证书下方内容 */}
                <div className="certificate-content">
                    <div className="title-section">
                        <div className="title">
                            <span className="star-icon star-left" />
                            <span
                                className="title-text"
                                dangerouslySetInnerHTML={{
                                    __html: `🎉 ${lang('恭喜你完成课程，<br />获得 UMU CAET 证书！')}`.replace(
                                        '<br />',
                                        !isMobile ? '' : '<br />',
                                    ),
                                }}
                            />
                            <span className="star-icon star-right" />
                        </div>
                        {showEmail && (
                            <div
                                className="description"
                                dangerouslySetInnerHTML={{
                                    __html: lang(
                                        '证书已发送至 ${email}，<br />可以在课程市场页AI力分类旁点击“CAET证书”，设置公开/私密、下载与分享。',
                                    ).replace('${email}', email),
                                }}
                            />
                        )}
                        {description && <div className="description">{description}</div>}
                    </div>
                </div>
            </div>
            {showContentInfo && (
                <div className="content-info">
                    {/* 权限控制部分 */}
                    {!hidePermissionControl && (
                        <PermissionControl isPublic={isPublic} onChange={handlePermissionChange} />
                    )}

                    {/* Footer 按钮 */}
                    {footerRender ? (
                        footerRender({
                            isPublic,
                            handlePermissionChange,
                            handleDownload,
                            handleManage,
                            handleConfirm,
                            showEmail,
                            email,
                        })
                    ) : (
                        <div className={`footer-buttons ${isMobile ? 'mobile-footer-buttons' : ''}`}>
                            <div className="left-buttons">
                                {footerButtonsConfig.download?.visible && (
                                    <Button
                                        type={footerButtonsConfig.download.type}
                                        onClick={footerButtonsConfig.download.onClick}
                                    >
                                        {isDownloading ? lang('下载中') : footerButtonsConfig.download.text}
                                    </Button>
                                )}
                            </div>
                            <div className="right-buttons">
                                {footerButtonsConfig.manage?.visible && (
                                    <Button
                                        type={footerButtonsConfig.manage.type}
                                        onClick={footerButtonsConfig.manage.onClick}
                                    >
                                        {footerButtonsConfig.manage.text}
                                    </Button>
                                )}
                                {footerButtonsConfig.confirm?.visible && (
                                    <Button
                                        type={footerButtonsConfig.confirm.type}
                                        onClick={footerButtonsConfig.confirm.onClick}
                                    >
                                        {footerButtonsConfig.confirm.text}
                                    </Button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
});
const onDialogCaetComplete = (data?: ICaetCompleteDialogProps) => {
    const { title = '', isMobile = false, afterClose, ...rest } = data || {};
    const dialog = confirm({
        title,
        centered: true,
        maskClosable: true,
        closable: false,
        width: isMobile ? '4.5rem' : '6.4rem',
        footer: null,
        className: 'complete-ai-power-recognition-dialog',
        content: <CaetComplete isMobile={isMobile} {...rest} onClose={() => dialog.destroy()} />,
        afterClose,
    });
    return dialog;
};
export { CaetComplete, onDialogCaetComplete };
